import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-archive-sale-method',
  templateUrl: './alert-archive-sale-method.component.html',
  styleUrls: ['./alert-archive-sale-method.component.css']
})
export class AlertArchiveSaleMethodComponent implements OnInit {

  innerHeight: number = window.innerHeight;

  currSalemethod: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<AlertArchiveSaleMethodComponent>,

  ) {
    this.currSalemethod = data.saleMethod;
   
  }

  ngOnInit() {
  }

  closeDial() {
    
    this.dialogRef.close();
  }


}
